import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var AddPopupRes;
export const AddPopupTodo = createAsyncThunk('AddPopup', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Post",
            url: process.env.REACT_APP_API_URL + 'popup_data',
            data: data ,
            headers: { "Content-Type": "multipart/form-data" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return AddPopupRes = res.data
        
    } catch (error) {
        return AddPopupRes = error.response.data
    }
})
